'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "size_units"],
  _excluded2 = ["line_type"];
import { fromJS, Map as ImmutableMap } from 'immutable';
import { getSocialNetworks } from 'EmailEditorUI/redux/selectors/socialNetworksSelectors';
import { getConvertedLinkStyleDefault, getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getDefaultFromSpec } from 'EmailEditorUI/utils/fieldUtils';
import { createNetwork, getModuleDefaultsKeyByType, isFollowMeModule, isEmailEcommModule, isEmailAbandonedCartModule, moduleSpecHasField, isEmailProductModule } from 'EmailEditorUI/utils/moduleUtils';
import { getUserModuleDefaults } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
import { getEffectiveStyleSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { MODULE_TYPES } from 'EmailData/constants/DefaultModulesConstants';
import { buttonDefaultBackgroundColorChange, buttonDefaultCornerRadiusChange, buttonDefaultFontChange, dividerDefaultColorChange, dividerDefaultHeightChange, dividerDefaultLineTypeChange } from 'EmailEditorUI/redux/actions/dndTemplateSettingsActions';
const EMPTY_DEFAULTS = ImmutableMap();
export const DEFAULTS_CHANGE_DEBOUNCE_TIME = 250;
const convertFontStyleToNewFontStyle = fontStyle => {
  const {
      size,
      size_units
    } = fontStyle,
    rest = _objectWithoutPropertiesLoose(fontStyle, _excluded);
  const isLegacyFontStyleFormat = typeof size === 'object';
  return Object.assign({
    size: isLegacyFontStyleFormat ? size.value : size,
    size_units: isLegacyFontStyleFormat ? size.units : size_units
  }, rest);
};
const getDividerModuleDefaults = (moduleSpec, userModuleDefaults) => {
  const dividerStyle = getDefaultFromSpec(moduleSpec, 'divider_styles');
  if (userModuleDefaults.email_divider) {
    const _userModuleDefaults$e = userModuleDefaults.email_divider,
      {
        line_type: defaultLineType
      } = _userModuleDefaults$e,
      dividerDefaults = _objectWithoutPropertiesLoose(_userModuleDefaults$e, _excluded2);
    return Object.assign({}, dividerDefaults, {
      line_type: defaultLineType || (dividerStyle === null || dividerStyle === void 0 ? void 0 : dividerStyle.line_type)
    });
  }
  return dividerStyle;
};
const getHardcodedModuleDefaults = (state, moduleSpec) => {
  let follow_me = {};
  let email_products = {};
  let email_abandoned_cart = {};
  let email_cart = {};
  let button_email = {};
  //checking the module version supports this feature
  if (moduleSpec && isFollowMeModule(moduleSpec.moduleId) && moduleSpecHasField(moduleSpec, 'font_style')) {
    var _fromJS;
    const linkDefault = getConvertedLinkStyleDefault(state);
    const moduleDefault = getDefaultFromSpec(moduleSpec, 'font_style');
    const defaultSocialNetworks = ['facebook', 'linkedin', 'twitter', 'instagram'];
    const portalSocialNetworks = getSocialNetworks(state);
    follow_me = {
      social: defaultSocialNetworks.map(social => createNetwork(social, portalSocialNetworks)),
      font_style: (_fromJS = fromJS(moduleDefault)) === null || _fromJS === void 0 ? void 0 : _fromJS.merge(linkDefault)
    };
  }
  if (moduleSpec && isEmailEcommModule(moduleSpec.moduleId)) {
    const userModuleDefaults = getUserModuleDefaults(state).toJS();
    const styleSettings = getEffectiveStyleSettings(state);
    const primaryFont = styleSettings.get('primary_font');
    const primaryFontColor = styleSettings.get('primary_font_color');
    const buttonDefaultStyle = getDefaultFromSpec(moduleSpec, 'button_styles') || {};
    let maybeButtonStyles = Object.assign({}, buttonDefaultStyle);
    if (userModuleDefaults.button_email) {
      const background_color = userModuleDefaults.button_email.background_color || buttonDefaultStyle.background_color;
      maybeButtonStyles = {
        button_styles: Object.assign({}, userModuleDefaults.button_email, {
          background_color,
          font_style: convertFontStyleToNewFontStyle(userModuleDefaults.button_email.font_style)
        })
      };
    }
    const fontStyles = getDefaultFromSpec(moduleSpec, 'font_styles') || {};
    const ecommStyles = Object.assign({
      font_styles: Object.assign({}, fontStyles, {
        product_name_font_style: Object.assign({}, fontStyles.product_name_font_style, {
          font: styleSettings.getIn(['heading_two_font', 'font']) || primaryFont,
          color: styleSettings.getIn(['heading_two_font', 'color']) || primaryFontColor
        }),
        description_font_style: Object.assign({}, fontStyles.description_font_style, {
          font: primaryFont,
          color: primaryFontColor
        }),
        price_font_style: Object.assign({}, fontStyles.price_font_style, {
          font: primaryFont,
          color: primaryFontColor
        })
      })
    }, maybeButtonStyles);
    const divider_styles = !isEmailAbandonedCartModule(moduleSpec.moduleId) ? getDividerModuleDefaults(moduleSpec, userModuleDefaults) : undefined;
    if (isEmailProductModule(moduleSpec.moduleId)) {
      const productsOverride = {
        products: []
      };
      email_products = Object.assign({
        divider_styles
      }, ecommStyles, productsOverride);
    } else if (isEmailAbandonedCartModule(moduleSpec.moduleId)) {
      email_abandoned_cart = Object.assign({}, ecommStyles, {
        font_styles: Object.assign({}, ecommStyles.font_styles, {
          quantity_font_style: Object.assign({}, fontStyles.quantity_font_style, {
            font: primaryFont,
            color: primaryFontColor
          })
        })
      });
    } else {
      email_cart = Object.assign({}, ecommStyles, {
        divider_styles,
        font_styles: Object.assign({}, ecommStyles.font_styles, {
          quantity_font_style: Object.assign({}, fontStyles.quantity_font_style, {
            font: primaryFont,
            color: primaryFontColor
          })
        })
      });
    }
  }
  const rich_text = {
    hs_enable_module_padding: !getIsSingleColumnFullWidth(state)
  };
  if (moduleSpec && moduleSpec.name === 'Payments') {
    const defaultLinkTo = getDefaultFromSpec(moduleSpec, 'link_to');
    const defaultButtonText = getDefaultFromSpec(moduleSpec, 'text');
    button_email = {
      link_to: defaultLinkTo,
      text: defaultButtonText
    };
  }
  return fromJS({
    rich_text,
    follow_me,
    email_products,
    email_abandoned_cart,
    email_cart,
    button_email
  });
};
export const getModuleDefaultsByType = (state, moduleType, moduleSpec) => {
  const hardcodedModuleDefault = getHardcodedModuleDefaults(state, moduleSpec);
  const userModuleDefaults = getUserModuleDefaults(state);

  // Any modules that don't have hard-coded defaults should be merged into
  // `hardcodedModuleDefault` right away
  const withoutHardcodedDefaults = userModuleDefaults.filter((value, key) => {
    return value && !hardcodedModuleDefault.has(key);
  });
  const moduleDefaultsOverride = hardcodedModuleDefault.merge(withoutHardcodedDefaults).map((hardCodedDefault, fieldName) => {
    const userDefaultForFieldName = userModuleDefaults.get(fieldName);
    return hardCodedDefault.merge(userDefaultForFieldName);
  });
  return moduleDefaultsOverride.get(getModuleDefaultsKeyByType(moduleType)) || EMPTY_DEFAULTS;
};
const CHANGE_HANDLER_ACTION_MAPPING = {
  [MODULE_TYPES.BUTTON]: {
    background_color: buttonDefaultBackgroundColorChange,
    corner_radius: buttonDefaultCornerRadiusChange,
    font_style: buttonDefaultFontChange
  },
  [MODULE_TYPES.DIVIDER]: {
    height: dividerDefaultHeightChange,
    color: dividerDefaultColorChange,
    line_type: dividerDefaultLineTypeChange
  }
};
export const getModuleDefaultsChangeHandler = (moduleType, fieldName) => {
  return CHANGE_HANDLER_ACTION_MAPPING[moduleType][fieldName];
};